/* eslint-disable @typescript-eslint/no-explicit-any */
import CryptoJS from "crypto-js";

export const H5_3DES_KEY = "np!u5chin@adm!n1aaaaaaa2";

function getAesString(data: string, key1: string, iv1: any) {
  // 加密
  const key = CryptoJS.enc.Utf8.parse(key1);
  const iv = CryptoJS.enc.Utf8.parse(iv1);
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString(); // 返回的是base64格式的密文
}

function getDAesString(encrypted: string, key1: string, iv1: string) {
  // 解密
  const key = CryptoJS.enc.Utf8.parse(key1);
  const iv = CryptoJS.enc.Utf8.parse(iv1);
  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * 3DES加密
 * @param str
 * @param key
 */
export function encryptBy3DES(str: string, key = H5_3DES_KEY) {
  let encrypt = "";

  try {
    const keyHex = CryptoJS.enc.Utf8.parse(key);
    const encrypted = CryptoJS.TripleDES.encrypt(str, keyHex, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    encrypt = encrypted.toString();
  } catch (error) {
    console.log(error);
  }

  if (encrypt.length === 0) {
    encrypt = str;
  }
  return encrypt;
}

/**
 * 3DES解密
 * @param str
 * @param desKey
 */
export function decryptBy3DES(str: string, desKey = H5_3DES_KEY) {
  let decrypt = "";
  try {
    if (str) {
      const key = CryptoJS.enc.Utf8.parse(desKey);
      const decrypted = CryptoJS.TripleDES.decrypt(str, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      decrypt = CryptoJS.enc.Utf8.stringify(decrypted).toString();
    }
  } catch (error) {
    console.log(error);
  }

  if (decrypt.length === 0) {
    decrypt = str;
  }
  return decrypt;
}

export default {
  encryptBy3DES,
  decryptBy3DES,
};
